import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSocket } from '../context/SocketContext';
import { useNavigate } from 'react-router-dom';

interface NotificationData {
    id: string;
    title: string;
    message: string;
    type: 'info' | 'success' | 'warning' | 'error';
    link?: string;
}

const AdminNotificationListener: React.FC = () => {
    const { socket } = useSocket();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [activeNotification, setActiveNotification] = useState<NotificationData | null>(null);

    useEffect(() => {
        if (!socket) return;

        const handleNewNotification = (data: NotificationData) => {
            console.log('🔔 New Admin Notification received via socket:', data);
            setActiveNotification(data);
            setOpen(true);
        };

        socket.on('new_admin_notification', handleNewNotification);

        return () => {
            socket.off('new_admin_notification', handleNewNotification);
        };
    }, [socket]);

    const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') return;
        setOpen(false);
    };

    const handleAction = () => {
        if (activeNotification?.link) {
            navigate(activeNotification.link);
        }
        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert
                onClose={handleClose}
                severity={activeNotification?.type || 'info'}
                variant="filled"
                sx={{ width: '100%', cursor: activeNotification?.link ? 'pointer' : 'default' }}
                onClick={activeNotification?.link ? handleAction : undefined}
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                <strong>{activeNotification?.title}</strong>
                <div style={{ fontSize: '0.875rem' }}>{activeNotification?.message}</div>
            </Alert>
        </Snackbar>
    );
};

export default AdminNotificationListener;
